import DataRoomFileAccess from './DataRoomFileAccess.component';

export default DataRoomFileAccess;
